<template>
  <div v-bind:key="refreshKey">
    <slot name="table-top-actions" v-bind:selectedIds="selectedIds"></slot>
    <!-- Top pagination -->
    <div class="mb-1 text-center">
      <div class="d-inline-block">
        <b-pagination
            v-model="pagination.page"
            v-bind:total-rows="pagination.total"
            v-bind:per-page="pagination.size"
            @page-click="onPageClick"
            align="center"
        ></b-pagination>
      </div>
      <div class="d-inline-block">
        <b-select class="d-inline-block" style="width: 70px" size="sm" v-model="pagination.size" @change="refresh">
          <b-select-option v-bind:value="25">25</b-select-option>
          <b-select-option v-bind:value="50">50</b-select-option>
          <b-select-option v-bind:value="100">100</b-select-option>
        </b-select>
        /{{ pagination.total }} {{ $t('columns.counterNames.affiliates') }}
      </div>
    </div>
    <b-table responsive v-handy-scroll v-bind:items="rows" v-bind:fields="fields" no-local-sorting
             v-bind:sort-by.sync="sort.field" v-bind:sort-desc.sync="sortIsDesc" v-resizable
             striped  hover @row-clicked="onRowClicked" v-bind:busy="loading"
             @sort-changed="onSortChanged"
             style="white-space: nowrap; padding-bottom: 30px"
    >
      <template #head(selection)="data">
        <b-form-checkbox v-bind:indeterminate="isIndeterminate(selected)" :checked="selected.all"
                         style="margin-top: 7px"
                         @change="val=>toggleAllRow(val)" inline
        ></b-form-checkbox>
      </template>
      <template #cell(orgId)="data">
        {{ getOrganizationNameById(data.value) }}
      </template>
      <template #cell(businessUnit)="data">
        {{ getBusinessUnitNameById(data.value) }}
      </template>

      <template  #cell(active)="data">
        <b-badge v-bind:variant="data.value ? 'success' : 'danger'">{{ data.value ? $t('yes') : $t('no') }}</b-badge>
      </template>
      <template  #cell(unforceClientDuplicate)="data">
        <b-badge v-bind:variant="data.value ? 'success' : 'danger'">{{ data.value ? $t('yes') : $t('no') }}</b-badge>
      </template>

      <!-- Current CPA: price + active date range -->
      <template #cell(currentCpa.cpa)="data">
        <div v-if="data.item.currentCpa && data.item.currentCpa.cpa != null" class="cpa-pill">
          <span class="cpa-pill__price">{{ convertToEURO(data.item.currentCpa.cpa) }}</span>
          <span v-if="hasCpaDates(data.item.currentCpa)" class="cpa-pill__dates">
            <i class="fa-regular fa-calendar"></i>
            <span>{{ cpaDateRange(data.item.currentCpa) }}</span>
          </span>
        </div>
        <span v-else class="text-muted">—</span>
      </template>

      <!-- Current CRG (+ period in weeks) -->
      <template #cell(currentCpa.crg)="data">
        <div v-if="data.item.currentCpa && data.item.currentCpa.crg != null">
          <span class="font-weight-bold">{{ data.item.currentCpa.crg }}</span>
          <small v-if="data.item.currentCpa.crgWeek != null" class="text-muted">/ {{ data.item.currentCpa.crgWeek }}w</small>
        </div>
        <span v-else class="text-muted">—</span>
      </template>

      <template #cell(selection)="data">
        <b-form-checkbox v-model="selectedIds[data.item.id]" inline @input="val=>toggleRow(data.item, val)"
        ></b-form-checkbox>
      </template>

      <template #cell(actions)="data">
        <b-button size="sm" variant="outline-danger" :title="$t('operations.delete')"
                  @click.stop="confirmDelete(data.item)">
          <i class="fa-solid fa-trash-can"></i>
        </b-button>
      </template>
    </b-table>
    <!--{{pagination}}-->
    <div class="mt-2 text-center">
      <div class="d-inline-block">
        <b-pagination
            v-model="pagination.page"
            v-bind:total-rows="pagination.total"
            v-bind:per-page="pagination.size"
            @page-click="onPageClick"
            align="center"
        ></b-pagination>
      </div>
      <div class="d-inline-block">
        <b-select class="d-inline-block" style="width: 70px" size="sm" v-model="pagination.size" @change="refresh">

          <b-select-option v-bind:value="25">25</b-select-option>
          <b-select-option v-bind:value="50">50</b-select-option>
          <b-select-option v-bind:value="100">100</b-select-option>
        </b-select>
        /{{ pagination.total }} {{ $t('columns.counterNames.affiliates') }}

      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import mixinTable from '@/components/mixin/mixinTable';
import mixinNotifications from '@/components/mixin/mixinNotifications';
import mixinBase from '@/components/mixin/mixinBase';
import mixinPermissions from '@/components/mixin/mixinPermissions';

export default {
  name: 'AffiliatesTable',
  mixins: [mixinBase, mixinTable, mixinNotifications, mixinPermissions],
  data: () => ({
    rows: [],
    selected: { all: false },
  }),
  props: {
    filters: {
      default: () => ({})
    },
    columns: {
      default: () => ([])
    },
    hasSelection: {
      default: () => false
    },
    lazy: {
      default: () => false
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.pagination.page = 1;
        this.refresh();
      }
    }
  },
  created() {
    this.setPagination(1, 0, 25);
    if (!this.lazy) {
      this.refresh();
    }
  },
  computed: {
    ...mapGetters('data', ['getBusinessUnitNameById', 'getOrganizationNameById','getUserFullName','getAffiliateNameById']),

    fields() {
      let $this = this;
      let label = (key) => key.includes('.') ? key.substring(key.lastIndexOf('.') + 1) : key
      let fields = (this.columns || []).map(column => {
        return {
          key: column.key,
          label: $this.$t(`columns.${label(column.key)}`),
          sortable: true,
          active: column.enable,
        };
      });
      if (this.hasSelection) {
        fields.unshift({
          key: 'selection',
          label: '',
          sortable: false,
          active: true,
        });
      }
      if (this.hasPermission(this.permissions.AFFILIATE_UPDATE)) {
        fields.push({
          key: 'actions',
          label: '',
          sortable: false,
          active: true,
          class: 'text-right',
        });
      }
      return fields.filter(f => f.active === true);
    },
    selectedIds() {
      this.refreshKey; // Little hack to recompile
      // console.log("selectedIds()",this.selected)
      return Object.keys(this.selected)
          .filter(k => k !== 'all')
          .reduce((ans, id) => Object.assign(ans, { [id]: true }), {});
    },
  },
  methods: {
    ...mapActions('affiliate', ['getAllAffiliates', 'deleteAffiliate']),
    // Soft-delete with confirmation — the row is only hidden from the table.
    confirmDelete(affiliate) {
      let $this = this;
      const name = affiliate.company || affiliate.alias || affiliate.email || affiliate.id;
      this.$bvModal.msgBoxConfirm($this.$t('operations.delete') + ' "' + name + '"?', {
        title: $this.$t('globalMessages.pleaseConfirm'),
        size: 'sm',
        okVariant: 'danger',
        okTitle: $this.$t('operations.yes'),
        cancelTitle: $this.$t('operations.no'),
        centered: true,
      }).then(value => {
        if (!value) return;
        $this.deleteAffiliate({ id: affiliate.id })
            .then(() => {
              $this.showSuccessNotification($this.$t('globalMessages.deleteDataSuccess', { system: name }));
              $this.refresh();
            })
            .catch(err => {
              $this.showErrorNotification($this.$t('globalMessages.deleteDataError', { system: name }), $this.getErrorDescription(err));
            });
      });
    },
    hasCpaDates(cpa) {
      return !!(cpa && (cpa.startDate || cpa.endDate));
    },
    cpaDateRange(cpa) {
      const fmt = d => (d ? this.$moment(d).format('DD/MM/YYYY') : null);
      const start = fmt(cpa.startDate);
      const end = fmt(cpa.endDate);
      if (start && end) return `${start} → ${end}`;
      if (start) return `${start} →`;
      if (end) return `→ ${end}`;
      return '';
    },
    async refresh() {
      let $this = this;
      let loadingToken = this.setLoading();
      let sort = { ...$this.sort };
      if (sort.field == null) {
        sort.field = 'lastUpdate';
      }

      // console.log("refresh()", {  pagination: this.pagination, sort})
      const result = await this.getAllAffiliates({pagination: this.pagination,sort,filter: this.filters,
          }
      )
          .catch(err => {
            $this.showErrorNotification($this.$t('globalMessages.fetchDataError', { system: $this.$t('menu.affiliates') }), $this.getErrorDescription(err));
            $this.setLoaded(loadingToken);
          });
      this.rows = result.data;
      this.setMetaDataFromResult(result);
      this.setLoaded(loadingToken);
    }
  }
};
</script>

<style scoped>
.cpa-pill {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}
.cpa-pill__price {
  font-weight: 700;
  font-size: 0.95rem;
  color: #28c76f;
  background: rgba(40, 199, 111, 0.12);
  border-radius: 6px;
  padding: 1px 8px;
  line-height: 1.4;
}
.cpa-pill__dates {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.72rem;
  color: #6e6b7b;
  white-space: nowrap;
}
.dark-layout .cpa-pill__dates {
  color: #b4b7bd;
}
</style>
